import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { selectAuth } from '@app/features/auth/auth.selectors';
import {
  APP_NAVIGATION_CONTEXT_DESCRIPTORS,
  hasRequiredAccess,
} from '@core/models/app-navigation.model';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

export const firstAllowedContextGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const router = inject(Router);

  return inject(Store)
    .select(selectAuth)
    .pipe(
      filter(
        (auth) =>
          auth.init &&
          !auth.sessionTransitioning &&
          (auth.accessStatus === 'ready' || auth.accessStatus === 'failed'),
      ),
      take(1),
      map((auth) =>
        router.parseUrl(
          auth.accessStatus === 'failed'
            ? '/access-unavailable'
            : getDefaultNavigationUrl(auth.access),
        ),
      ),
    );
};

export function getDefaultNavigationUrl(access: readonly string[]): string {
  const target = APP_NAVIGATION_CONTEXT_DESCRIPTORS.find(
    ({ access: required }) => hasRequiredAccess(access, required),
  );

  return target?.route ?? '/forbidden';
}
